<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="请求日志" name="http">
      <log-http></log-http>
    </el-tab-pane>
    <el-tab-pane label="COS日志" name="cos">
      <log-cos></log-cos>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import LogHttp from "@/components/sysSet/LogHttp.vue";
import LogCos from "@/components/sysSet/LogCos.vue";

export default {
  name: 'Log',
  components: {LogCos, LogHttp},
  data() {
    return {
      activeName: 'http'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style scoped>

</style>